
import checkLogo from '../../assets/Icons/SVG/Asset 3.svg';
import { Image } from 'react-bootstrap';
import './InfoList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

const InfoList = () => {
  return (
    <div className="infoListContainer">
      <Image src={checkLogo} className='checkLogo' />
      <h3 className='infoListHeader'>Quickly & Simply Eliminate:</h3>
      <ul>
        <li className='infoListItem'>
          <FontAwesomeIcon style={{ paddingRight: '1rem' }} icon={faCircleCheck} />
          <div>TOBACCO SMOKE</div>
        </li>
        <li className='infoListItem'>
          <FontAwesomeIcon style={{ paddingRight: '1rem' }} icon={faCircleCheck} />
          VAPING ODORS
        </li>
        <li className='infoListItem'>
          <FontAwesomeIcon style={{ paddingRight: '1rem' }} icon={faCircleCheck} />
          HVAC ODORS
        </li>
        <li className='infoListItem'>
          <FontAwesomeIcon style={{ paddingRight: '1rem' }} icon={faCircleCheck} />
          MOLD SMELL
        </li>
        <li className='infoListItem'>
          <FontAwesomeIcon style={{ paddingRight: '1rem' }} icon={faCircleCheck} />
          CANNABIS ODORS
        </li>
      </ul>
    </div >
  )
}

export default InfoList;